import React from "react";
import Colors from "../../../assets/colors/Colors";
import {ColumnDivF1} from "../../styledComponents/CustomStyledComponents";

import styled from "styled-components";

const StyledTierLegend = styled.div`
  flex: 1;
  display: flex;
  color: ${(props: {isLife: boolean}) => (props.isLife ? Colors.fontWhite: Colors.fontGray)};

  & .color-label {
    width: 17px;
    height: 17px;
    margin: auto 10px;
  }

  & .text-label {
    font-family: DMSans-Light;
    font-size: 23px;
  }
`;

const TierComponent: React.FC<{isLife: boolean}> = ({isLife}) => {
    const tiers = [
        {label: 'Tier 1', color: Colors.tiers.tier1},
        {label: 'Tier 2', color: Colors.tiers.tier2},
        {label: 'Tier 3', color: Colors.tiers.tier3}
    ];
    return (
        <ColumnDivF1 style={{fontSize: 20}}>
            {
                tiers.map((tier, index) => (
                    <StyledTierLegend key={index} isLife={isLife}>
                        <div className='color-label' style={{backgroundColor: tier.color }} />
                        <div className='text-label'>{tier.label}</div>
                    </StyledTierLegend>
                ))
            }
        </ColumnDivF1>
    )
};

export default TierComponent;
